export enum FlightType {
  DOMESTIC = 'DOM',
  INTERNATIONAL = 'INT',
}
